import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiAgeProgressionConfig } from '@/data/landingConfig/landingAiAgeProgressionConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiAgeProgression } from './schemaObject';

interface Props {}
const AiAgeProgression: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiAgeProgression} />
			<LandingTemplate
				data={landingAiAgeProgressionConfig}
				funnelLinkService={GenerateLandingLinkService.funnelAgeProgression()}
			/>
		</>
	);
};

export default AiAgeProgression;
